import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../Core/Store/store';

export interface IPageItem {
  id: string;
  name: string;
  thumbnailUrl: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

interface PageItemsState {
  items: IPageItem[];
  isCustomizeOpen: boolean;
  pageIndex: number;
}

const initialState: PageItemsState = {
  items: [],
  isCustomizeOpen: false,
  pageIndex: -1,
};

export const pageItemsSlice = createSlice({
  name: 'pageItems',
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<IPageItem[]>) => {
      state.items = action.payload;
    },
    updateItemPosition: (
      state,
      action: PayloadAction<{ id: string; x: number; y: number }>
    ) => {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) {
        item.x = action.payload.x;
        item.y = action.payload.y;
      }
    },
    updateItemSize: (
      state,
      action: PayloadAction<{ id: string; width: number; height: number }>
    ) => {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) {
        item.width = action.payload.width;
        item.height = action.payload.height;
      }
    },
    updateItemField: (
      state,
      action: PayloadAction<{ id: string; field: keyof IPageItem; value: number | string }>
    ) => {
      const item = state.items.find((i) => i.id === action.payload.id);
      if (item) {
        (item as any)[action.payload.field] = action.payload.value;
      }
    },
    openCustomize: (state, action: PayloadAction<number>) => {
      state.isCustomizeOpen = true;
      state.pageIndex = action.payload;
    },
    closeCustomize: (state) => {
      state.isCustomizeOpen = false;
      state.pageIndex = -1;
    },
    clearItems: (state) => {
      state.items = [];
      state.isCustomizeOpen = false;
      state.pageIndex = -1;
    },
  },
});

export const {
  setItems,
  updateItemPosition,
  updateItemSize,
  updateItemField,
  openCustomize,
  closeCustomize,
  clearItems,
} = pageItemsSlice.actions;

export const selectPageItems = (state: RootState) => state.pageItems.items;
export const selectIsCustomizeOpen = (state: RootState) => state.pageItems.isCustomizeOpen;
export const selectCustomizePageIndex = (state: RootState) => state.pageItems.pageIndex;

export default pageItemsSlice.reducer;
